export const FALLBACK_VALUE = 'onbekend';

